import { createContext } from 'react'

import { ModalTypes } from './registry'

export interface ModalContext<Props extends Record<string, unknown>> {
    type?: ModalTypes
    props?: Props
    openModal: <Props>(type: ModalTypes, props?: Props) => void
    closeModal: () => void
}

export const Context = createContext<ModalContext<{}>>({
    openModal: () => {},
    closeModal: () => {},
})
